export const progressiveFormLeadScoreFieldName = 'score';
export const progressiveFormConsentFieldName = 'consent';
